<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content" v-menu-permission="'list'">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="repairSppOrderResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" inlineActionsDisabled :query-api="$_emWorkflowListMixin_queryApi"
                        :ref="modelName+'Table'" exportDisabled checkboxColumnDisabled editDisable  with-custom-row-actions-first-column>
                <template #customRowActionsFirstColumn="{row}">
                  <b-button-group>
                    <em-button type="task"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="$_emWorkflowListMixin_handleApprove(row)">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
  // Author thq
  // Date 2022-02-14 13:50:08
  import emWorkflowListMixin from "@/mixin/em/workflow/list";

  export default {
    name: "repairSppOrderWorkflowListView",
    mixins: [emWorkflowListMixin],
    computed: {
      modelName() {
        return this.$_emRouterHelperMixin_entityName
      }
    }
  };
</script>